<template>
  <b-row>
    <b-col lg="12">
      <b-row>
        <!-- badge name -->
        <b-col lg="12">
          <div class="form-group">
            <label>{{ $t("badges.name") }}</label>
            <input v-model="newItem.name" type="text" class="form-control" />
          </div>
        </b-col>

        <!-- badge description -->
        <b-col lg="12">
          <div class="form-group">
            <label>{{ $t("badges.description") }}</label>
            <ckeditor :config="{ contentsLangDirection : 'rtl',versionCheck : false}" v-model="newItem.description" />
          </div>
        </b-col>
        <!-- image -->
        <b-col lg="12">
          <div class="form-group">
            <label>{{ $t("badges.image") }}</label>
            <input
              type="file"
              name="image"
              accept="image/*"
              class="form-control load-image"
              @change="previewImage($event)"
            />
            <img
              v-if="url != null"
              width="200"
              height="200"
              :src="url"
              class="loaded-image"
            />
          </div>
        </b-col>
      </b-row>

      <hr />
      <b-row>
        <b-col lg="6">
          <b-button
            block
            :disabled="invalid"
            variant="primary"
            @click="submit()"
          >
            <i class="fa fa-plus" /> {{ $t("site.save") }}</b-button
          >
        </b-col>
        <b-col lg="6">
          <b-button block  @click="goToTable()" variant="success" >
            <i class="fas fa-ban"></i> {{ $t("site.cancel") }}</b-button
          >
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import controller from "../../../../Controllers/BadgesController";
import config from "../../../../config/config";
import { ValidationProvider, ValidationObserver } from "vee-validate";

import { required, email } from "@validations";
export default {
  props: ["newItem"],
  components: {
    // validations
    ValidationProvider,
    ValidationObserver,
   },
  data() {
    return {
      // image: null,
      file: {},
      url: null,
      
    };
  },
  watch: {},
  created() {
    delete this.newItem.image;
  },
  methods: {
     goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      let ret = await new controller().From(this.newItem, "FormData");
      if (ret) {
        this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
        this.$parent.$parent.firstTab();
      }
    },
    previewImage(event) {
      console.log("event", event.target.files[0]);
      const _file = event.target.files[0];

      this.newItem.image = _file;
      this.url = URL.createObjectURL(_file);
    },
  },
};
</script>

<style></style>
